import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-actions" }

import AppIcon from '@/components/common/app-icon/AppIcon.vue';
import CustomTooltip from '@/components/common/tooltip/CustomTooltip.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConversationActions',
  props: {
    isAllowedClipboard: { type: Function }
  },
  emits: ["action"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;
const handleOnClickCopyButton = () => emit('action', 'copy');
const handleOnClickInsertButton = () => emit('action', 'insert');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isAllowedClipboard ? _ctx.isAllowedClipboard() : true)
      ? (_openBlock(), _createBlock(CustomTooltip, {
          key: 0,
          message: _ctx.$t('legal_assistant.actions.copy'),
          position: "bottom",
          size: "small"
        }, {
          default: _withCtx(() => [
            _createVNode(AppIcon, {
              name: "copy-text",
              size: "body-xl",
              "class-name": "color-lighter",
              onClick: handleOnClickCopyButton,
              clickable: true
            })
          ]),
          _: 1
        }, 8, ["message"]))
      : _createCommentVNode("", true),
    _createVNode(CustomTooltip, {
      message: _ctx.$t('legal_assistant.actions.insert'),
      position: "bottom",
      size: "small"
    }, {
      default: _withCtx(() => [
        _createVNode(AppIcon, {
          name: "insert-text",
          size: "body-xl",
          "class-name": "color-lighter",
          onClick: handleOnClickInsertButton,
          clickable: true
        })
      ]),
      _: 1
    }, 8, ["message"])
  ]))
}
}

})